import React, { Component } from 'react';

import API from 'API';

import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class ChimneyList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        const chimneyTypes = await API.call('book/list-chimney-types');
        this.setState({
            chimneyTypes,
            isLoading: false
        });
    }

    render() {
        const { isLoading, isBusy, chimneyTypes } = this.state;
        const { accountInfo, bookingRequest, onBackClicked, onNextClicked, onAddClicked, onChangeClicked, onRemoveClicked } = this.props;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            <h2>Your chimneys:</h2>

            <div className="chimneys-table-container">
                <table className="chimneys-table">
                    <tbody>
                        {bookingRequest.chimneyTypeIDs.map((ctID, index) => {
                            const chimneyType = chimneyTypes.find(ct => ct.id == ctID);
                            return (
                                <tr key={index}>
                                    <td>{chimneyType?.name || 'Don\'t Know / Other'}</td>
                                    <td className="actions-col">
                                        <button className="btn btn-secondary" onClick={() => onChangeClicked(index)}>
                                            Change type
                                        </button>
                                        {bookingRequest.chimneyTypeIDs.length > 1 &&
                                            <button className="btn btn-secondary" onClick={() => {
                                                const confirm = window.confirm('Remove this chimney?');
                                                if (confirm) {
                                                    onRemoveClicked(index);
                                                }
                                            }}>
                                                Remove
                                            </button>
                                        }
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            
            <div className="btn-stack">

                {bookingRequest.chimneyTypeIDs.length >= 4 ? <>
                    <p>You have selected the maximum number of chimneys. If you need more, please call us on {accountInfo.landlineTel}.</p>
                </> :
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => onAddClicked()}
                        disabled={isBusy}
                    >
                        Add another chimney
                    </button>
                }
                
            </div>
            
            <div className="nav-buttons">

                <button type="button" className="btn btn-secondary me-auto" onClick={() => onBackClicked()} disabled={isBusy}>
                    Back
                </button>

                <button
                    type="button"
                    className="btn ms-auto"
                    onClick={() => onNextClicked()}
                    disabled={isBusy}
                >
                    {isBusy ?
                        <><Loader isInline />{' '}Please Wait...</> :
                        <>Next</>
                    }
                </button>
                
            </div>

        </>);
    }

}

export default ChimneyList;